import { baseAxios, errorHandler } from "../index";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";

export function loginKoordinatorProduktif(dispatch, data, history) {
  Swal.fire({
    title: "Tunggu ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  return baseAxios
    .post("/webApiBpd/loginKoordinatorProduktif", data)
    .then((response) => {
      let { fullname, email, koordinator, user_id } = response.data.data.data;
      Swal.close();

      let result = {
        success: true,
        data: { fullname, email, koordinator, user_id },
      };
      return result;
    })
    .catch((err) => {
      errorHandler(err.response);
    });
}

export function requestOtp(data) {
  return baseAxios
    .post("/webApiBpd/requestOtp", data)
    .then((response) => {
      let dataLogin = response.data.exp;
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(dataLogin),
        "your-secret-key"
      ).toString();

      localStorage.setItem("Exp", encryptedData);
      return response.data;
    })
    .catch((err) => {
      console.log(err, "ERROR");
      throw err;
    });
}

export function sendOtp(dispatch, data, history) {
  Swal.fire({
    title: "Tunggu ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .post("/webApiBpd/verifikasiOtp", data)
    .then(async (respon) => {
      Swal.close();
      let dataLogin = {
        Role: "BPD",
        Otp: true,
        Kategori: "Produktif",
      };
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(dataLogin),
        "your-secret-key"
      ).toString();

      localStorage.setItem("Data", encryptedData);
      localStorage.setItem("token", respon.data.data.token);
      // localStorage.setItem("Role", "BPD");
      // localStorage.setItem("Kategori", "Produktif");

      dispatch({
        type: "SET_IDENTITY_KOORDINATOR_PRODUKTIF",
        data: {
          fullname: respon.data.data.fullname,
          email: respon.data.data.email,
          koordinator: respon.data.data.koordinator,
        },
      });
      history.push("/koorproduktif/pengajuanKoordinatorProduktif");
    })
    .catch((err) => {
      console.log(err, "ERRR");
      errorHandler(err.response);
    });
}

export function refreshKoordinatorProduktif(dispatch) {
  Swal.fire({
    title: "Tunggu ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .get("/webApiBpd/refreshLoginKoorProduktif", {
      headers: { token: localStorage.getItem("token") },
    })
    .then(async (respon) => {
      let { fullname, email, koordinator } = respon.data.data.data;
      // let dataLogin = {
      //   Role: "BPD",
      //   Otp: true,
      //   Kategori: "Produktif",
      // };
      // const encryptedData = CryptoJS.AES.encrypt(
      //   JSON.stringify(dataLogin),
      //   "your-secret-key"
      // ).toString();

      // localStorage.setItem("Data", encryptedData);
      // localStorage.setItem("token", respon.data.data.token);
      // localStorage.setItem("Role", "BPD");
      // localStorage.setItem("Kategori", "Produktif");

      dispatch({
        type: "SET_IDENTITY_KOORDINATOR_PRODUKTIF",
        data: { fullname, email, koordinator },
      });
      Swal.close();
    })
    .catch(errorHandler);
}

export function gantiPasswordKoordinatorProduktif(dispatch, data, history) {
  baseAxios
    .post("webApiBpd/ubahPasswordBpd", data, {
      headers: {
        token: localStorage.getItem("token"),
      },
    })
    .then(async (respon) => {
      Swal.fire({
        position: "center",
        icon: "success",
        title: respon.data.message,
        showConfirmButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          // localStorage.removeItem("token");
          localStorage.clear();
          window.location.replace("/auth/login-page");
        }
      });
    })
    .catch(errorHandler);
}
